import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SelectedTimezoneModel } from '../../store/models/local-date.model';
import { getTimezoneTextById } from '../../common/utils/date.helpers';
import { IconNames } from '../../common/constants/icon-names';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-date-with-profile-and-local-timezone',
  imports: [CommonModule, IntrackFeatureModule, TranslateModule, SvgIconComponent],
  templateUrl: './date-with-profile-and-local-timezone.component.html',
  styleUrls: ['./date-with-profile-and-local-timezone.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateWithProfileAndLocalTimezoneComponent {
  @Input() timestamp: number;
  @Input() set localTimezoneData(localTimezone: SelectedTimezoneModel) {
    this.localTimezone = localTimezone;

    if (localTimezone) {
      this.localTimezoneText = getTimezoneTextById(localTimezone.timezone);
    }
  }
  @Input() set profileTimezoneData(profileTimezone: SelectedTimezoneModel) {
    this.profileTimezone = profileTimezone;

    if (profileTimezone) {
      this.profileTimezoneText = getTimezoneTextById(profileTimezone.timezone);
    }
  }
  @Input() dateFormat: string;

  localTimezone: SelectedTimezoneModel;
  profileTimezone: SelectedTimezoneModel;
  localTimezoneText: string;
  profileTimezoneText: string;
  iconNames = IconNames;
}
